import styled from "styled-components/macro";

export const StyledQuotaDisplayBar = styled.div`
  width: 100%;
  background: var(--container-color);
  height: 20px;
  border-radius: 20px;
  position: relative;
  margin-bottom: 10px;

  div {
    background: var(--menu-color);
    height: 20px;
    ${({ filledAmount }) => filledAmount !== false && `width: ${filledAmount}%`};
    min-width: 5%;
    border-radius: 20px;
    // box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
    box-shadow: var(--high-contrast-drop-shadow);
  }

  body[data-theme-type="dark"] & {
    div {
      background: var(--menu-color-active);
    }
  }
`;

export const StyledQuotaBar = styled.div`
  width: 100%;
  position: static;
  padding: 0px 14px;
  box-sizing: border-box;
  padding-top: 20px;
  margin-bottom: 20px;
  .sw2 & {
    border-top: 2px solid var(--grey-3);
  }

  span {
    font-size: 14px;
    padding-top: 10px;
    color: var(--grey-1);
    font-weight: 500;
  }

  button {
    float: right;
    padding: 10px 20px !important;
    border-radius: 20px !important;
    line-height: inherit;
  }
`;

export const StyledUpgradeButton = styled.button`
  white-space: nowrap;
  max-height: 36px;
  margin: 0 !important;
  padding: 0px 10px !important;
  border-radius: 4px !important;
  ${({ reverse }) =>
    reverse &&
    `
   background: none !important;
    color: var(--primary-cta-high-contrast) !important;

    &:hover {
    background: var(--container-color) !important;
    color: var(--primary-cta-high-contrast) !important;
  }
  `}

  &:hover {
    background: var(--primary-cta-hover);
    color: var(--cta-text-color);
  }
`;

export const StyledUnderBar = styled.div`
  display: flex;
  align-items: center;
  /* margin-top: 20px; */

  span {
    margin-right: 20px;
    padding: 0;
  }
`;

export const StyledQuotaBarSpan = styled.span`
  line-height: 1.3em;
  padding: 0;
  margin: 0;
  width: 100%;
  vertical-align: center;
`;
